import styled from '@emotion/styled'

import { Frame } from './Frame'

export const ShadowedFrame = styled(Frame)`
  background-color: ${(props) => props.theme.colors.winterWhite};
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
  border-radius: ${(props) => props.theme.radii.lg};
`
